module.exports = __webpack_public_path__ + "img/veza-6NP.1e7a4ae2.png";